<script>
  import ConfigureOnlineLicenseLoginAsprovaId from "./ConfigureOnlineLicenseLoginAsprovaId.svelte";
  import ConfigureOnlineLicenseSelectSerial from "./ConfigureOnlineLicenseSelectSerial.svelte";

  /**
   * @type {"loginAsprovaId" | "selectSerial"}
   */
  export let currentPage = "loginAsprovaId"

  export let onClose

  /**
   * @type {string | null}
   */
  let asprovaId = null

  /**
   * @type {string | null}
   */
  let password = null

  /**
   * @type {string | null}
   */
  let accessTokenLicenseList = null

  /**
   *
   * @param {{
   *   accessToken: string,
   *   asprovaId: string,
   *   password: string,
   * }} data
   */
  function moveToSelectSerial(data) {
    accessTokenLicenseList = data.accessToken
    asprovaId = data.asprovaId
    password = data.password

    currentPage = "selectSerial"
  }

</script>

{#if currentPage === "loginAsprovaId"}
  <ConfigureOnlineLicenseLoginAsprovaId
    onClickClose={onClose}
    moveNext={moveToSelectSerial}
  />
{/if}
{#if currentPage === "selectSerial" && accessTokenLicenseList}
  <ConfigureOnlineLicenseSelectSerial
    onClickClose={onClose}
    accessTokenLicenseList={accessTokenLicenseList}
    asprovaId={asprovaId}
    password={password}
  />
{/if}